import { render, staticRenderFns } from "./suspectUserHistory.vue?vue&type=template&id=69e0c8c1"
import script from "./suspectUserHistory.vue?vue&type=script&lang=js"
export * from "./suspectUserHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69e0c8c1')) {
      api.createRecord('69e0c8c1', component.options)
    } else {
      api.reload('69e0c8c1', component.options)
    }
    module.hot.accept("./suspectUserHistory.vue?vue&type=template&id=69e0c8c1", function () {
      api.rerender('69e0c8c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/suspectUserHistory.vue"
export default component.exports